import React from 'react';
import { TableRow, TableCell, TableBody } from '@mui/material';
import { AttachmentItem } from '@kimuno/api-sdk/lib/types/responses/Common';

import AttachmentTableRow from './AttachmentTableRow';
import { customSizes } from '../../assets/styles/themes/tokens';

interface AttachmentsTableBodyProps {
    visibleRows: AttachmentItem[];
    onClickItemBody: (name: string, type: string) => void;
    onClickItemCheckbox: (fileName: string) => void;
    onClickItemDownload: (fileName: string) => Promise<void>;
    selected: readonly string[];
    emptyRows: number;
    nestedLevel: number;
}

const AttachmentsTableBody  = ({
  visibleRows,
  onClickItemBody,
  onClickItemCheckbox,
  onClickItemDownload,
  selected,
  emptyRows,
  nestedLevel,
}: AttachmentsTableBodyProps) => {

  return (
    <TableBody>
      {visibleRows.map((row) => (
        <AttachmentTableRow
          key={row.fileName}
          row={row}
          isItemSelected={selected.indexOf(row.fileName) !== -1}
          onClickItem={() => onClickItemBody(row.name, row.type)}
          onClickCheckBox={() => onClickItemCheckbox(row.fileName)}
          onClickItemDownload={() => onClickItemDownload(row.fileName)}
          nestedLevel={nestedLevel}
        />)
      )}
      {emptyRows > 0 && (
        <TableRow
          sx={{
            height: customSizes.attachmentsRowHeight * emptyRows,
            '& .MuiTableCell-root': {
              borderBottom: 'none',
            },
          }}
        >
          <TableCell colSpan={6} />
        </TableRow>
      )}
    </TableBody>
  );
};

export default AttachmentsTableBody;
